import type { ScrollToTop as ScrollToTopSchema } from '@amplience/content-types/typings/c-scroll-to-top';
import { ArrowUpSmall } from '../../../icons';
import { getLocalizedValue } from '../../../utils/transformers';
import { ScrollToTopButton, Text } from './ScrollToTop.styles';

export type ScrollToTopProps = ScrollToTopSchema & {
  isDesktop?: boolean;
  isCategoryPage?: boolean;
  focusReset?: () => void;
};
export function ScrollToTop({ scrollToTopMessage, isDesktop, isCategoryPage, focusReset }: ScrollToTopProps) {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    if (focusReset) {
      focusReset();
    }
  };

  return (
    <ScrollToTopButton
      $isDesktop={isDesktop}
      $isCategoryPage={isCategoryPage}
      data-testid="scrollToTopButton"
      type="button"
      onClick={scrollToTop}
    >
      <ArrowUpSmall />
      {scrollToTopMessage ? <Text>{getLocalizedValue(scrollToTopMessage)}</Text> : null}
    </ScrollToTopButton>
  );
}
